<section class="sd-section">
  <div class="sd-wrapper">
    <div class="sd-wrapper-inner">

      <!-- Logo -->
      <div class="sd-logo">
        <a href="javascript:void(0)">
          <img [src]="brandLogo" alt="Crizac" title="Crizac" class="logo-img" />
        </a>
      </div>

      <!-- Missed sign-off notice -->
      <div class="sd-missed-signoff" *ngIf="missedSignOff">
        <mat-icon>error_outline</mat-icon>
        <span>You did not sign off properly last time. Please remember to sign off at the end of every work day.</span>
      </div>

      <!-- Clock -->
      <div class="sd-punch-info">
        <p class="sd-punch-label">Punching in at</p>
        <h1 class="sd-punch-time">{{ currentTime }}</h1>
        <p class="sd-punch-date">{{ currentDate }}</p>
      </div>

      <!-- Business as Usual checkbox -->
      <div class="sd-bau-card">
        <mat-checkbox [(ngModel)]="businessAsUsual" class="sd-bau-checkbox">
          Business as Usual
        </mat-checkbox>
      </div>

      <!-- Optional beyond-regular question -->
      <div class="sd-form-group">
        <label class="sd-focus-label">
          Is there anything you are planning today to initiate or accomplish beyond regular work and tasks?
          <span class="sd-optional-hint">(optional)</span>
        </label>
        <mat-form-field appearance="outline" class="sd-focus-field">
          <textarea
            matInput
            [(ngModel)]="focusLine"
            [maxlength]="maxLength"
            placeholder="e.g. Propose a new workflow for agent onboarding, or research a new CRM integration..."
            rows="4">
          </textarea>
        </mat-form-field>
      </div>

      <!-- CTA -->
      <button
        class="sd-start-btn"
        mat-raised-button
        type="button"
        (click)="onStartDay()"
        [disabled]="!businessAsUsual"
        [style.background-color]="businessAsUsual ? buttonBgColor : null"
        [style.color]="businessAsUsual ? buttonTextColor : null">
        Start My Day
      </button>

      <p class="sd-copyright text-center">© {{ currentYear }} {{ companyName }}. All rights reserved.</p>

    </div>
  </div>
</section>